"use client";

import { createContext, useContext, useState } from "react";

interface AdminContextType {
    isUploadModalOpen: boolean;
    setIsUploadModalOpen: (open: boolean) => void;
}

const AdminContext = createContext<AdminContextType | undefined>(undefined);

export function AdminProvider({ children }: { children: React.ReactNode }) {
    const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);

    return (
        <AdminContext.Provider value={{ isUploadModalOpen, setIsUploadModalOpen }}>
            {children}
        </AdminContext.Provider>
    );
}

export function useAdmin() {
    const context = useContext(AdminContext);
    if (context === undefined) {
        throw new Error("useAdmin must be used within an AdminProvider");
    }
    return context;
}
